/**
 * @generated SignedSource<<f9bd7e7c86ad08d13b4dafb1dc0e72e5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_jiraViewResult$data = {
  readonly __typename: string;
  readonly viewSettings?: {
    readonly hideDone: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult" | "ui_issueTableGroupByDropdown_GroupByDropdown_spreadsheetView">;
  readonly " $fragmentType": "main_issueNavigator_Header_jiraViewResult";
};
export type main_issueNavigator_Header_jiraViewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_jiraViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_jiraViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_jiraViewResult",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
          "kind": "FragmentSpread",
          "name": "ui_issueTableGroupByDropdown_GroupByDropdown_spreadsheetView"
        },
        {
          "kind": "FragmentSpread",
          "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SaveResetViewSettingsButton"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hideDone"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};

(node as any).hash = "83197bb27a6b94fed13959b1459d1e7e";

export default node;
